import { render, staticRenderFns } from "./addIpConfig.vue?vue&type=template&id=451f7618&"
import script from "./addIpConfig.vue?vue&type=script&lang=js&"
export * from "./addIpConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports